import { Component, Input, OnChanges } from '@angular/core';
import { ActivatedDetailsComponentData } from './activated-details.model';
import { ActivatedDetailsFacade } from './activated-details.facade';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BrokerStatus } from '@partner/shared/SharedConstants';
import { SubmissionDetailsActionsService } from '../../actions/submission-details-actions.service';
import { SubmissionDetailsParams } from '../../submission-details.model';

@UntilDestroy()
@Component({
    selector: 'ifbp-activated-details',
    templateUrl: './activated-details.component.html',
    styleUrls: ['./activated-details.component.scss'],
    providers: [ActivatedDetailsFacade],
    standalone: false
})
export class ActivatedDetailsComponent implements OnChanges {
  viewData: ActivatedDetailsComponentData;
  readonly BrokerStatus = BrokerStatus;

  @Input()
  params: SubmissionDetailsParams;

  constructor(
    private readonly facade: ActivatedDetailsFacade,
    private readonly actions: SubmissionDetailsActionsService,
  ) { }

  ngOnChanges(): void {
    this.initData();
  }

  private initData() {
  return this.facade.getComponentData$(this.params.appId).pipe(untilDestroyed(this))
      .subscribe(data => {
        this.viewData = data;
        this.actions.markDataAsLoaded(true);
      });
  }
}
